export enum SwitcherType {
    ON = 'on',
    OFF = 'off',
}